<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view" class="data-list-container">
		<vs-table :sst="true" class="shadow-none border-none" stripe :data="$store.state.moduleUser && $store.state.moduleUser.users2" @sort="handleSort">
			<div slot="header" class="w-full mb-12 flex">
				<h4 class="font-bold">Danh sách nhân viên</h4>
				<div class="flex flex-grow justify-end">
					<vs-input @input="handleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="'Tìm theo SĐT'" v-model="searchText" />
					<div class="md:flex lg:flex xl:flex hidden vs-con-loading__container" ref='btnExport'>
						<div class="md:flex lg:flex xl:flex hidden ml-3">
							<vs-button title="Tải tổng hợp sản lượng tháng" class="w-48 font-bold" type="filled" @click="exportData(null)">Tải báo cáo</vs-button>
						</div>
					</div>
				</div>
			</div>
			<template slot="thead">
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">STT</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Tên nhân viên</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Số điện thoại</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Đơn vị</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Tình trạng hiện tại</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Lần khai báo gần nhất</h6></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
					<vs-td>
						<p class="word-break">
							{{ ((page - 1) * $store.state.moduleUser.limit) + indextr + 1 }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break uppercase">
							{{ tr.hoten }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break">
							{{ tr.sdt }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break">
							{{ tr.congty }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'word-break': 1}">
							{{ tr.lichtrinh }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break">
							{{ $helper.momentFormatLocale(tr.created_at, 'DD/MM/YYYY HH:mm', 7) }}
						</p>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="w-full center mt-4">
			<CbsPagination :total="total" v-model="page"></CbsPagination>
		</div>
		<UserDetail v-if="isDetailUserDialogActive" :data="detailUserDialogData" :isSidebarActive="isDetailUserDialogActive" @closeSidebar="toggleDetailSidebar" />
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";

export default {
	components: {
		CbsPagination, UserDetail,
	},
	data() {
		return {
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			filters: {
				status: 3
			}
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleUser.total2 / this.$store.state.moduleUser.limit);
		}
	},
	methods: {
		exportData() {
			this.$nextTick(() => {
				this.$vs.loading({
					container: this.$refs.btnExport
				})
			});
			this.$store.dispatch("moduleCustomer/exportData", '?status=1').then((response) => {
				console.log('response: ', response);
				this.$vs.loading.close(this.$refs.btnExport);
				if (response && response.url) {
					window.location = process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+response.url;
				}
			}).catch(err => {
				this.$vs.loading.close(this.$refs.btnExport);
			});
		},
		async getGetUsers() {
			this.$vs.loading();
			const payload = {
				filters: this.filters,
				sort: this.sort,
				projection: {
					email: 1,
					fullname: 1,
					overview: 1
				},
				paging: {
					page: this.page,
					limit: this.$store.state.moduleUser.limit
				}
			};
			try {
				await this.$store.dispatch("moduleUser/fetchUsers2", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},

		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key;// `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ', ': ''}${zone.name}` : '';
				return zones;
			}, '');
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		}
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		}
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
	}
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
